module.exports = __webpack_public_path__ + "media/images/icons/outlined/setting-d969ab094d2813cc7c39c463e374a02c.svg";